<header>
  <div class="header-inner">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="sidebar_logo">
            <a [routerLink]="headerLogoRouterLink()">
              <img src="assets/images/logo.png" class="img-fluid" alt="logo" />
            </a>
          </div>
        </div>
        <div class="col text-end">
          @if (globals.baseRoute == 'directory') {
            <div class="directory">
              <button class="back_to_website">Back to Website</button>
            </div>
          }
          @if (globals.baseRoute != 'directory') {
            <div
              class="header-right-icons"
              >
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
                >
                <span class="navbar-toggler-icon"></span>
              </button>
              @if (globals.authData) {
                <div class="dropdown header_profile">
                  <a
                    class="dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    >
                    <!-- <img
                  [src]="
                    globals.authData.user_logo
                      ? globals.baseAPIFolderUrl +
                        '/' +
                        globals.authData.user_logo
                      : 'assets/images/user.png'
                  "
                    class="img-fluid"
                    alt="user"
                    /> -->
                    <div class="user-avatar">
                      <div class="sort-name">
                        {{ globals.authData.name_initials }}
                      </div>
                    </div>
                    <div class="header_profile_info">
                      <span>{{ globals.authData.username }}</span>
                      <span
                        class="cci_id_badge"
                        kendoTooltip
                        position="bottom"
                    title="This is your unique account ID, CCI staff may ask you to
                  confirm this ID to ensure accurate correspondence."
                        >{{ globals.authData.cci_id }}</span
                        >
                      </div>
                    </a>
                    <small class="profile-role"
                      >{{ currentRole.label }}
                      @if (ddUserRoles.length > 1) {
                        <button
                          (click)="openSwitchRoleDialog()"
                          class="switch-btn"
                          >
                          Switch
                        </button>
                      }
                    </small>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <div class="user_profile_options">
                        <ul>
                          <li>
                            <a (click)="setProfileLink()"
                              ><i class="ri-user-3-fill"></i> Profile</a
                              >
                            </li>
                            <!-- <li>
                            <a routerLink="/payment-history"
                              ><i class="ri-money-dollar-circle-fill"></i> Payment
                              History</a
                              >
                            </li> -->
                            @if (
                              globals.authData.app_count &&
                              globals.authData.app_count > 1
                              ) {
                              <li
                                >
                                <a routerLink="/professional/history"
                                  ><i class="ri-money-dollar-circle-fill"></i> Application
                                  History</a
                                  >
                                </li>
                              }
                              @if (currentRole.slug === 'candidate') {
                                <li>
                                  <a routerLink="/payment-history"
                                    ><i class="ri-money-dollar-circle-fill"></i> Payment
                                    History</a
                                    >
                                  </li>
                                }
                                <li>
                                  <a routerLink="/settings"
                                    ><i class="ri-settings-5-fill"></i>Password & Account
                                    Settings</a
                                    >
                                  </li>
                                  @if (!isCurrentlyImpersonating()) {
                                    <li>
                                      <a (click)="logout()"
                                        ><i class="ri-logout-box-r-line"></i> Sign Out</a
                                        >
                                      </li>
                                    }
                                    @if (isCurrentlyImpersonating()) {
                                      <li>
                                        <a (click)="stopImpersonation()"
                                          ><i class="ri-logout-box-r-line"></i> Stop
                                          Impersonation</a
                                          >
                                        </li>
                                      }
                                    </ul>
                                  </div>
                                </ul>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                @if (globals.baseRoute != 'directory') {
                  <div
                    class="nagivation_block d-flex align-item-center justify-content-start"
                    >
                    <div class="container-fluid">
                      <nav class="navbar navbar-expand-lg navbar-light w-100">
                        <div
                          class="collapse navbar-collapse justify-content-between"
                          id="navbarNav"
                          >
                          <ul class="navbar-nav">
                            @if (globals.isCandidate) {
                              <li
              [ngClass]="{
                active: globals.currentLink.split('/')[1] == 'professional',
              }"
                                >
                                <a routerLink="/professional">Dashboard </a>
                              </li>
                            }
                            @if (globals.isCandidate) {
                              <li
              [ngClass]="{
                active: globals.currentLink.split('/')[1] == 'my-activities',
              }"
                                >
                                <a routerLink="/my-activities">My Activities</a>
                              </li>
                            }
                            @if (globals.isCandidate) {
                              <li
              [ngClass]="{
                active: globals.currentLink.split('/')[1] == 'store',
              }"
                                >
                                <a id="openss">Store <i class="ri-arrow-down-s-line"></i></a>
                                <div class="submenu dropdown-menu" id="popupss">
                                  <div class="width_menu mega_menu text-nowrap">
                                    <ul>
                                      <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'store' &&
                          globals.currentLink.split('/')[2] == null,
                      }"
                                        >
                                        <a routerLink="/store">All Products</a>
                                      </li>
                                      <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'store' &&
                          globals.currentLink.split('/')[2] == 'cart',
                      }"
                                        >
                                        <a routerLink="/store/cart">Cart</a>
                                      </li>
                                      <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'store' &&
                          globals.currentLink.split('/')[2] == 'orders',
                      }"
                                        >
                                        <a routerLink="/store/orders">Order History</a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>
                            }
                            @if (
                              globals.isItAdmin ||
                              globals.isAdmin ||
                              globals.isAuditor ||
                              globals.isCredentialManager ||
                              globals.isAccountant
                              ) {
                              <li
              [ngClass]="{
                active:
                  globals.currentLink.split('/')[1] == 'my-admin' &&
                  globals.currentLink.split('/')[2] != 'manage' &&
                  globals.currentLink.split('/')[2] != 'configuration',
              }"
                                >
                                <a id="open">My Admin <i class="ri-arrow-down-s-line"></i></a>
                                <div class="submenu dropdown-menu" id="popup">
                                  <!-- <div class="width_menu mega_menu"> -->
                                  <div class="width_menu mega_menu text-nowrap">
                                    <ul>
                                      @if (globals.isItAdmin || globals.isAdmin) {
                                        <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'my-admin' &&
                          globals.currentLink.split('/')[2] == 'dashboard',
                      }"
                                          >
                                          <a routerLink="/my-admin/dashboard">Dashboard</a>
                                        </li>
                                      }
                                      @if (globals.isItAdmin || globals.isAdmin) {
                                        <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'my-admin' &&
                          globals.currentLink.split('/')[2].split('?')[0] ==
                            'applications',
                      }"
                                          >
                                          <a routerLink="/my-admin/applications">Applications</a>
                                        </li>
                                      }
                                      @if (
                                        globals.isItAdmin ||
                                        globals.isAdmin ||
                                        globals.isAuditor ||
                                        globals.isAccountant
                                        ) {
                                        <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'my-admin' &&
                          globals.currentLink.split('/')[2].split('?')[0] ==
                            'audit',
                      }"
                                          >
                                          <a routerLink="/my-admin/audit">Audit</a>
                                        </li>
                                      }
                                      @if (globals.isItAdmin || globals.isAdmin) {
                                        <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'my-admin' &&
                          globals.currentLink.split('/')[2].split('?')[0] ==
                            'exams',
                      }"
                                          >
                                          <a routerLink="/my-admin/exams">Exams</a>
                                        </li>
                                      }
                                      @if (globals.isItAdmin || globals.isAdmin) {
                                        <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'my-admin' &&
                          globals.currentLink.split('/')[2].split('?')[0] ==
                            'facilities',
                      }"
                                          >
                                          <a routerLink="/my-admin/facilities">Facilities</a>
                                        </li>
                                      }
                                      @if (
                                        globals.isItAdmin ||
                                        globals.isAdmin ||
                                        globals.isCredentialManager
                                        ) {
                                        <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'my-admin' &&
                          globals.currentLink.split('/')[2].split('?')[0] ==
                            'users',
                      }"
                                          >
                                          <a routerLink="/my-admin/users">Users</a>
                                        </li>
                                      }
                                      <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'my-admin' &&
                          globals.currentLink.split('/')[2].split('?')[0] ==
                            'tickets',
                      }"
                                        >
                                        <a routerLink="/my-admin/tickets">Tickets</a>
                                      </li>
                                      <!-- <li *ngIf="globals.isItAdmin || globals.isAdmin">
                                      <a routerLink="/my-admin/volunteer-management"
                                        >Volunteer Management</a
                                        >
                                      </li>
                                      <li *ngIf="globals.isItAdmin || globals.isAdmin">
                                        <a routerLink="/my-admin/vouchers">Vouchers</a>
                                      </li> -->
                                    </ul>
                                    <!-- <ul *ngIf="globals.isItAdmin || globals.isAdmin">
                                    <li>
                                      <span class="title">Exam Score</span>
                                      <ul class="submenu dropdown-menu">
                                        <li>
                                          <a routerLink="/my-admin/exam-score-reports"
                                            >All Reports</a
                                            >
                                          </li>
                                          <li>
                                            <a routerLink="/my-admin/result-import">Import</a>
                                          </li>
                                        </ul>
                                      </li>
                                      <li *ngIf="globals.isItAdmin || globals.isAdmin">
                                        <span class="title">Reports</span>
                                        <ul class="submenu dropdown-menu">
                                          <li>
                                            <a routerLink="/my-admin/reports/applications"
                                              >Applications</a
                                              >
                                            </li>
                                            <li>
                                              <a routerLink="/my-admin/reports/ceus">CEUs</a>
                                            </li>
                                            <li>
                                              <a routerLink="/my-admin/reports/exams">Exams</a>
                                            </li>
                                            <li>
                                              <a routerLink="/my-admin/reports/users">Users</a>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul> -->
                                      <ul>
                                        @if (globals.isItAdmin || globals.isAdmin) {
                                          <li>
                                            <span class="title">Reports</span>
                                            <ul class="submenu dropdown-menu">
                                              <li
                          [ngClass]="{
                            active:
                              globals.currentLink.split('/')[1] == 'my-admin' &&
                              globals.currentLink.split('/')[2] ==
                                'activity-report',
                          }"
                                                >
                                                <a routerLink="/my-admin/activity-report"
                                                  >Activities</a
                                                  >
                                                </li>
                                                <li
                          [ngClass]="{
                            active:
                              globals.currentLink.split('/')[1] == 'my-admin' &&
                              globals.currentLink.split('/')[2] ==
                                'applications-report',
                          }"
                                                  >
                                                  <a routerLink="/my-admin/applications-report"
                                                    >Applications</a
                                                    >
                                                  </li>
                                                  <li
                          [ngClass]="{
                            active:
                              globals.currentLink.split('/')[1] == 'my-admin' &&
                              globals.currentLink.split('/')[2] ==
                                'cancelled-orders-report',
                          }"
                                                    >
                                                    <a routerLink="/my-admin/cancelled-orders-report"
                                                      >Cancelled Orders</a
                                                      >
                                                    </li>
                                                    <li
                          [ngClass]="{
                            active:
                              globals.currentLink.split('/')[1] == 'my-admin' &&
                              globals.currentLink.split('/')[2] ==
                                'exams-report',
                          }"
                                                      >
                                                      <a routerLink="/my-admin/exams-report">Exams</a>
                                                    </li>
                                                    <li
                          [ngClass]="{
                            active:
                              globals.currentLink.split('/')[1] == 'my-admin' &&
                              globals.currentLink.split('/')[2] ==
                                'user-credentials-report',
                          }"
                                                      >
                                                      <a routerLink="/my-admin/user-credentials-report"
                                                        >User Credentials</a
                                                        >
                                                      </li>
                                                    </ul>
                                                  </li>
                                                }
                                              </ul>
                                            </div>
                                          </div>
                                        </li>
                                      }
                                      @if (
                                        globals.isFacility &&
                                        globals.selectedFacility &&
                                        globals.selectedFacility.role.id == 1
                                        ) {
                                        <li
              [ngClass]="{
                active: globals.currentLink.split('/')[1] == 'facility',
              }"
                                          >
                                          <a id="open"
                                            >Facility Portal <i class="ri-arrow-down-s-line"></i
                                          ></a>
                                          <div class="submenu dropdown-menu" id="popup">
                                            <div class="width_menu mega_menu text-nowrap">
                                              <ul>
                                                <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'facility' &&
                          globals.currentLink.split('/')[2] == 'manage',
                      }"
                                                  >
                                                  <a routerLink="/facility/manage">Manage Information</a>
                                                </li>
                                                <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'facility' &&
                          globals.currentLink.split('/')[2] == 'users',
                      }"
                                                  >
                                                  <a routerLink="/facility/users">Users</a>
                                                </li>
                                                <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'facility' &&
                          globals.currentLink.split('/')[2] == 'vouchers',
                      }"
                                                  >
                                                  <a routerLink="/facility/vouchers">Vouchers</a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </li>
                                      }
                                      @if (globals.isFacility && globals.selectedFacility) {
                                        <li
              [ngClass]="{
                active: globals.currentLink.split('/')[1] == 'facility-store',
              }"
                                          >
                                          <a id="openss"
                                            >Facility Store <i class="ri-arrow-down-s-line"></i
                                          ></a>
                                          <div class="submenu dropdown-menu" id="popupss">
                                            <div class="width_menu mega_menu text-nowrap">
                                              <ul>
                                                <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] ==
                            'facility-store' &&
                          globals.currentLink.split('/')[2] == null,
                      }"
                                                  >
                                                  <a routerLink="/facility-store">All Products</a>
                                                </li>
                                                <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] ==
                            'facility-store' &&
                          globals.currentLink.split('/')[2] == 'cart',
                      }"
                                                  >
                                                  <a routerLink="/facility-store/cart">Cart</a>
                                                </li>
                                                <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] ==
                            'facility-store' &&
                          globals.currentLink.split('/')[2] == 'orders',
                      }"
                                                  >
                                                  <a routerLink="/facility-store/orders">Order History</a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </li>
                                      }
                                      <li
              [ngClass]="{
                active: globals.currentLink.split('/')[1] == 'tickets',
              }"
                                        >
                                        <a id="open" routerLink="tickets">My Tickets</a>
                                      </li>
                                      @if (globals.isItAdmin || globals.isAdmin) {
                                        <li
              [ngClass]="{
                active: globals.currentLink.split('/')[1] == 'manage',
              }"
                                          >
                                          <a id="opens">Manage <i class="ri-arrow-down-s-line"></i></a>
                                          <div class="submenu dropdown-menu" id="popups">
                                            <div class="width_menu mega_menu text-nowrap">
                                              <ul>
                                                @if (globals.isItAdmin || globals.isAdmin) {
                                                  <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'manage' &&
                          globals.currentLink.split('/')[2] ==
                            'audit-percentage',
                      }"
                                                    >
                                                    <a routerLink="/manage/audit-percentage"
                                                      >Audit Percentages</a
                                                      >
                                                    </li>
                                                  }
                                                  @if (globals.isItAdmin || globals.isAdmin) {
                                                    <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'manage' &&
                          globals.currentLink.split('/')[2] ==
                            'certification-products',
                      }"
                                                      >
                                                      <a routerLink="/manage/certification-products"
                                                        >Certification Products</a
                                                        >
                                                      </li>
                                                    }
                                                    <!-- <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'manage' &&
                          globals.currentLink.split('/')[2] == 'discount-codes',
                      }"
                                                    *ngIf="globals.isItAdmin || globals.isAdmin"
                                                    >
                                                    <a routerLink="/manage/discount-codes">Discount Codes</a>
                                                  </li> -->
                                                  @if (globals.isItAdmin || globals.isAdmin) {
                                                    <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'manage' &&
                          globals.currentLink.split('/')[2] ==
                            'facility-products',
                      }"
                                                      >
                                                      <a routerLink="/manage/facility-products"
                                                        >Facility Products</a
                                                        >
                                                      </li>
                                                    }
                                                    @if (globals.isItAdmin || globals.isAdmin) {
                                                      <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'manage' &&
                          globals.currentLink.split('/')[2] ==
                            'individual-products',
                      }"
                                                        >
                                                        <a routerLink="/manage/individual-products"
                                                          >Individual Products</a
                                                          >
                                                        </li>
                                                      }
                                                      @if (globals.isItAdmin || globals.isAdmin) {
                                                        <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'manage' &&
                          globals.currentLink.split('/')[2] == 'welcome-note',
                      }"
                                                          >
                                                          <a routerLink="/manage/welcome-note">Welcome Note</a>
                                                        </li>
                                                      }
                                                      @if (globals.isItAdmin) {
                                                        <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'manage' &&
                          globals.currentLink.split('/')[2] ==
                            'application-terms-and-conditions',
                      }"
                                                          >
                                                          <a routerLink="/manage/application-terms-and-conditions"
                                                            >Application Terms and Condition</a
                                                            >
                                                          </li>
                                                        }
                                                        @if (globals.isItAdmin) {
                                                          <li
                      [ngClass]="{
                        active:
                          globals.currentLink.split('/')[1] == 'manage' &&
                          globals.currentLink.split('/')[2] ==
                            'facility-purchase-terms-and-conditions',
                      }"
                                                            >
                                                            <a
                                                              routerLink="/manage/facility-purchase-terms-and-conditions"
                                                              >Facility Purchase Terms and Condition</a
                                                              >
                                                            </li>
                                                          }
                                                        </ul>
                                                        <ul>
                                                          @if (globals.isItAdmin || globals.isAdmin) {
                                                            <li>
                                                              <span class="title">Ticket</span>
                                                              <ul class="submenu dropdown-menu">
                                                                <li
                          [ngClass]="{
                            active:
                              globals.currentLink.split('/')[1] == 'manage' &&
                              globals.currentLink.split('/')[2] ==
                                'ticket-committees',
                          }"
                                                                  >
                                                                  <a routerLink="/manage/ticket-committees"
                                                                    >Committees</a
                                                                    >
                                                                  </li>
                                                                  <li
                          [ngClass]="{
                            active:
                              globals.currentLink.split('/')[1] == 'manage' &&
                              globals.currentLink.split('/')[2] ==
                                'ticket-sub-topic',
                          }"
                                                                    >
                                                                    <a routerLink="/manage/ticket-sub-topic"
                                                                      >Topic/Subtopic</a
                                                                      >
                                                                    </li>
                                                                  </ul>
                                                                </li>
                                                              }
                                                              @if (globals.isItAdmin || globals.isAdmin) {
                                                                  <li
                                                                    [ngClass]="{
                                                                      active:
                                                                        globals.currentLink.split('/')[1] == 'manage' &&
                                                                        globals.currentLink.split('/')[2] == 'release-notes'
                                                                    }"
                                                                  >
                                                                    <a routerLink="/manage/release-notes">
                                                                      Release Notes
                                                                    </a>
                                                                  </li>
                                                                }
                                                            </ul>
                                                          </div>
                                                        </div>
                                                      </li>
                                                    }
                                                    @if (!globals.selectedFacility) {
                                                      <li
              [ngClass]="{
                active:
                  globals.currentLink.split('/')[1] == 'facility' &&
                  globals.currentLink.split('/')[2] == 'register',
              }"
                                                        >
                                                        <a routerLink="/facility/register">Register your Facility</a>
                                                      </li>
                                                    }
                                                    <!-- LMS (with external link icon) -->
                                                    @if (globals.isCandidate) {
                                                      <li class="external-link">
                                                        <a (click)="openLMS()">My Classroom <i class="ri-external-link-line"></i
                                                        ></a>
                                                      </li>
                                                    }
                                                    @if (
                                                      (globals.isItAdmin || globals.isAdmin) &&
                                                      !isCurrentlyImpersonating()
                                                      ) {
                                                      <li
                                                        >
                                                        <a (click)="showImpersonateDialog()">Impersonate</a>
                                                      </li>
                                                    }
                                                    <!-- <li
                                                    *ngIf="globals.isItAdmin || globals.isAdmin"
            [ngClass]="{
              active:
                globals.currentLink.split('/')[1] == 'my-admin' &&
                globals.currentLink.split('/')[2] == 'configuration'
            }"
                                                    >
                                                    <a id="openss">Configurations <i class="ri-arrow-down-s-line"></i></a>
                                                    <div class="submenu dropdown-menu" id="popupss">
                                                      <div class="width_menu mega_menu">
                                                        <ul>
                                                          <li>
                                                            <a routerLink="/my-admin/configuration/ceu-activity"
                                                              >CEU Activities</a
                                                              >
                                                            </li>
                                                            <li>
                                                              <a routerLink="/my-admin/configuration/dates">Dates</a>
                                                            </li>
                                                            <li>
                                                              <a routerLink="/my-admin/configuration/exam-cycle"
                                                                >Exam Cycle</a
                                                                >
                                                              </li>
                                                              <li>
                                                                <a routerLink="/my-admin/configuration/fees">Fees</a>
                                                              </li>
                                                              <li>
                                                                <a routerLink="/my-admin/configuration/links">Links/URLs</a>
                                                              </li>
                                                            </ul>
                                                            <ul>
                                                              <li>
                                                                <span class="title">Welcome Note</span>
                                                                <ul class="submenu dropdown-menu">
                                                                  <li>
                                                                    <a routerLink="/my-admin/configuration/welcome-note/all"
                                                                      >For All</a
                                                                      >
                                                                    </li>
                                                                    <li>
                                                                      <a
                                                                        routerLink="/my-admin/configuration/welcome-note/not-certified"
                                                                        >Profile Pending (Not Certified)</a
                                                                        >
                                                                      </li>
                                                                      <li>
                                                                        <a
                                                                          routerLink="/my-admin/configuration/welcome-note/certified"
                                                                          >Profile Pending (Certified)</a
                                                                          >
                                                                        </li>
                                                                        <li>
                                                                          <a
                                                                            routerLink="/my-admin/configuration/welcome-note/directory-volunteer"
                                                                            >Directory & Volunteer Pending</a
                                                                            >
                                                                          </li>
                                                                        </ul>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                </div>
                                                              </li> -->
                                                              <!-- <li>
                                                              <a id="opens">Manage <i class="ri-arrow-down-s-line"></i></a>
                                                              <div class="submenu dropdown-menu" id="popups">
                                                                <div class="width_menu">
                                                                  <li>
                                                                    <a routerLink="/my-admin/vouchers">Vouchers</a>
                                                                  </li>
                                                                </div>
                                                              </div>
                                                            </li> -->
                                                          </ul>
                                                        </div>
                                                        <div class="clearfix"></div>
                                                      </nav>
                                                    </div>
                                                  </div>
                                                }
                                                <!-- Exit or stop Impersonation -->
                                                @if (isCurrentlyImpersonating()) {
                                                  <div class="exit-impersonation">
                                                    <div class="ei-inner">
                                                      Impersonation session active
                                                      <button type="button" (click)="stopImpersonation()">Exit</button>
                                                    </div>
                                                  </div>
                                                }
                                              </header>

                                              @if (switchRoleDialog) {
                                                <kendo-dialog
                                                  title="Switch Role"
                                                  (close)="closeSwitchRoleDialog()"
                                                  [width]="450"
                                                  >
                                                  <div class="k-form-field">
                                                    <kendo-dropdownlist
                                                      [(ngModel)]="roleToSwitch"
                                                      [data]="ddUserRoles"
                                                      textField="label"
                                                      valueField="id"
                                                      >
                                                    </kendo-dropdownlist>
                                                  </div>
                                                  <div class="text-center">
                                                    <button
                                                      type="button"
                                                      kendoButton
                                                      (click)="closeSwitchRoleDialog()"
                                                      class="all_btn secondary_btn"
                                                      >
                                                      Cancel
                                                    </button>
                                                    <button
                                                      kendoButton
                                                      [disabled]="roleToSwitch.slug == globals.userCurrentRole.slug"
      (click)="
        roleToSwitch.slug == globals.userCurrentRole.slug ? null : switchRole()
      "
                                                      class="all_btn primary_btn"
                                                      >
                                                      Change
                                                    </button>
                                                  </div>
                                                </kendo-dialog>
                                              }

                                              @if (impersonateDialog) {
                                                <kendo-dialog
                                                  title="Start Impersonation Session"
                                                  (close)="closeImpersonateDialog()"
                                                  [width]="450"
                                                  >
                                                  <div class="k-form-field">
                                                    <label class="default_lbl"
                                                      ><span class="text-danger mendatory">*</span>Whom do you want to
                                                      impersonate?</label
                                                      >
                                                      <kendo-dropdownlist
                                                        [(ngModel)]="impersonateUser"
                                                        [data]="filteredUserList"
                                                        textField="name"
                                                        valueField="id"
                                                        [filterable]="true"
                                                        (filterChange)="ddFilterUser($event)"
                                                        [loading]="userListLoading"
                                                        >
                                                        <ng-template kendoDropDownListValueTemplate let-dataItem>
                                                          @if (dataItem.id) {
                                                            {{ dataItem.name ? dataItem.name : dataItem.email }}
                                                            @if (dataItem.cci_id) {
                                                              <span class="cci_id_badge">{{
                                                                dataItem.cci_id
                                                              }}</span>
                                                            }
                                                          }
                                                          @if (!dataItem.id) {
                                                            {{ dataItem.name }}
                                                          }
                                                        </ng-template>
                                                        <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                          <div class="d-block w-100">
                                                            {{ dataItem.name }}
                                                            @if (dataItem.cci_id) {
                                                              <span class="cci_id_badge">{{
                                                                dataItem.cci_id
                                                              }}</span>
                                                            }
                                                            @if (dataItem.email) {
                                                              <br />({{ dataItem.email }})
                                                            }
                                                          </div>
                                                        </ng-template>
                                                        <ng-template kendoDropDownListNoDataTemplate let-dataItem>
                                                          No data found. Enter at least 3 characters (CCI ID, name, or email) to
                                                          search.
                                                        </ng-template>
                                                      </kendo-dropdownlist>
                                                    </div>
                                                    <div class="text-center mb-3">
                                                      You will temporarily switch to this account. Do you want to continue?
                                                    </div>
                                                    <div class="text-center">
                                                      <button
                                                        type="button"
                                                        kendoButton
                                                        (click)="closeImpersonateDialog()"
                                                        class="all_btn secondary_btn"
                                                        >
                                                        Cancel
                                                      </button>
                                                      <button
                                                        kendoButton
                                                        [disabled]="!impersonateUser?.id"
                                                        (click)="!impersonateUser?.id ? null : startImpersonateSession()"
                                                        class="all_btn primary_btn"
                                                        >
                                                        Confirm
                                                      </button>
                                                    </div>
                                                  </kendo-dialog>
                                                }
